const Redeem = {
  path: "",
  name: "",
  redirect: "/redeem",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/redeem",
      redirect: "/redeem",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Redeem",
      meta: {
        requiresAuth: true,
        activeUrl: "/redeem",
        parent: "redeem",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/redeem/index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/redeem",
            parent: "redeem",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Redeem Detail",
          component: () => import("@/views/pages/redeem/detail/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/redeem",
            parent: "redeem",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Redeem;
